module.exports = __webpack_public_path__ + "static/media/logout.d8635873.svg";